import React, { memo } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
} from "@material-ui/core";
import IconClose from "app/common/Icon/IconClose";
import Draggable from "react-draggable";

function Popup(props) {
  const {
    title,
    open,
    id = "draggable-dialog-title",
    handleClose,
    size = "md",
    children,
    action,
    hiddenClose = false,
    position,
    height,
  } = props;

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={size}
      aria-labelledby={id}
      className="popup-container"
      scroll="paper"
      PaperComponent={PaperComponent}
      PaperProps={{
        style:
          position === "top"
            ? {
                position: "absolute",
                top: "5%",
                margin: 0,
                transform: "none",
              }
            : {},
      }}
    >
      {Boolean(title) && (
        // <div className="flex align-center py-2 justify-between">
        <>
          <DialogTitle id={id} className="popup-header title ">
            <p className="titleText py-1 ">
              {typeof title === "function" ? title() : title}
            </p>
          </DialogTitle>

          {!hiddenClose && (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              style={{ position: "absolute", right: "0px", color: "white" }}
              className="popup__iconBtn font-size-32"
            >
              <IconClose className="popup__icon font-size-32" color="white" />
            </IconButton>
          )}
        </>
        // </div>
      )}

      <DialogContent
        dividers
        className="content popup-content"
        style={height ? { height: height } : {}}
      >
        {children}
      </DialogContent>

      {action && (
        <DialogActions className="action-popup-form">
          {typeof action === "function" ? action() : action}
        </DialogActions>
      )}
    </Dialog>
  );
}
function PaperComponent(props) {
  return (
    <Draggable
      handle={`#draggable-dialog-title`}
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default memo(Popup);
